import React from 'react';
import { Search } from 'lucide-react';
import './TableSearch.css';

interface TableSearchProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
}

export const TableSearch: React.FC<TableSearchProps> = ({ 
  value, 
  onChange, 
  placeholder = 'BUSCAR...', 
  className = '' 
}) => {
  return (
    <div className={`table-search-wrapper ${className}`.trim()}>
      <Search className="table-search-icon" size={14} />
      <input
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="table-search-input"
      />
    </div>
  );
};
